import visit from 'unist-util-visit';
import { TextAnalysis, TextAnalysisCategory, TextAnalysisResult } from '../SermonAnalyzer';

export default function ParagraphLength() {
    const recommendedParagrahLength = 6;

    let totalParagraphCount:number = 0;
    let longParagraphCount:number = 0;

    return transformer;
    
    function transformer(tree: any, file: any) {

        visit(tree, "ParagraphNode", increment);
        
        function increment(paragraph:any) {
            let sentenceCount:number = paragraph.children.filter((c:any) => c.type === "SentenceNode" ).length;
            
            if(sentenceCount > recommendedParagrahLength) {
                longParagraphCount++;
            };

            totalParagraphCount++;
            
            return visit.SKIP
        }
        
        if(totalParagraphCount === 0){
            return;
        }

        let longParagraphs:TextAnalysis = getLongParagraphText(Math.round((longParagraphCount / totalParagraphCount) * 100));

        if(longParagraphs.result === TextAnalysisResult.improvement){
            file.improvements.push(longParagraphs);
        } else {
            file.goodResults.push(longParagraphs);
        };
    };
    
    function getLongParagraphText(percentage:number){
        let result:TextAnalysis = {title: TextAnalysisCategory.paragraph_length, displayText: "", helperText: "Percentage based on number of paragraphs that have 6 or more complete sentences"};
        if (percentage > 25) {
            result.displayText = `${percentage}% of your paragraphs contain more than 6 sentences, which is more than the recommended maximum of 25%.`;
            result.result = TextAnalysisResult.improvement;
        } else {
            result.displayText = "Great! None of your paragraphs are too long.";
            result.result = TextAnalysisResult.goodResult;
        }
        return result;
    }
}
